export default __webpack_public_path__ + "static/media/Dissolvable Tobacco.374d05e4.png";